import { Icon, IconProps } from '@chakra-ui/react'

export default function CalendarIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#343A40'}
      {...props}
    >
      <path
        d="M5 .25a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0V3.75H3c-.69 0-1.25.56-1.25 1.25v3.25h16.5V5c0-.69-.56-1.25-1.25-1.25h-.5a.75.75 0 010-1.5h.5A2.75 2.75 0 0119.75 5v13A2.75 2.75 0 0117 20.75H3A2.75 2.75 0 01.25 18V5A2.75 2.75 0 013 2.25h1.25V1A.75.75 0 015 .25zM1.75 18c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V9.75H1.75V18zM13 .25a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0V3.75H8.5a.75.75 0 010-1.5h3.75V1A.75.75 0 0113 .25z"
        fill="currentColor"
      />
    </Icon>
  )
}
